import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AssistantContextService} from 'app/blocks/service/assistant-context/assistant-context.service';

/**
 * Records failed API calls (method, path without query, status, the server's short message, how long it took — never
 * bodies) and calls slower than 5 s for the Assistant's screen context, so "why did that fail?" can be answered. They are
 * only sent inside a screen context the user attached (CU-14zefhy1qnh). The CoPilot's own failed calls are kept too, except
 * its `chat/events/` polling (CU-14zefhy1r4j; the service decides). Read-only: never changes the request, the response
 * or the error.
 */
@Injectable()
export class AssistantContextInterceptor implements HttpInterceptor {
    constructor(private assistantContext: AssistantContextService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const started = Date.now();
        return next.handle(request).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        this.assistantContext.recordTiming(request.method, request.url, Date.now() - started);
                        // RMA-51: a successful save makes the field errors of the earlier 400 stale
                        this.assistantContext.recordSuccess(request.method, request.url);
                    }
                },
                error: (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        const ms = Date.now() - started;
                        this.assistantContext.recordApiError(request.method, request.url, err.status, err.error, ms);
                        this.assistantContext.recordTiming(request.method, request.url, ms);
                    }
                }
            })
        );
    }
}
